// Core packages
import React, { useEffect, useState } from "react";

// Third party packages
import { Tab, Tabs } from "react-bootstrap";
import { connect } from "react-redux";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

// Custom packages
import Footer from "../Footer";
import Foto from "./media/Foto";
import Video from "./media/Video";
import close from "../../assets/icone/close.png";
import cat from "../../data/categorie.json";
import PUBLIC_URL from '../../config/index';
import Pin from "../../components/Pin";
import Direzione from "../../components/Direction";

/**
 * Script start
 */
const Content = (props) => {
  const { closeFn, luogo, t } = props;
  const [more, setMore] = useState(false);

  // const closeHandle = () => {
  //   document.getElementById("popup-info").style.display = "none";
  // };

  const toDegreesMinutesAndSeconds = (coordinate) => {
    const absolute = Math.abs(coordinate);
    const degrees = Math.floor(absolute);
    const minutesNotTruncated = (absolute - degrees) * 60;
    const minutes = Math.floor(minutesNotTruncated);
    const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
    return degrees + " ° " + minutes + "' " + seconds + '"';
  };

  const convertDMS = (lat, lng) => {
    const latitude = toDegreesMinutesAndSeconds(lat);
    const latitudeCardinal = lat >= 0 ? "N" : "S";
    const longitude = toDegreesMinutesAndSeconds(lng);
    const longitudeCardinal = lng >= 0 ? "E" : "W";
    return (
      <p className="descr text-regular">
        <strong>{latitudeCardinal}</strong> {latitude} &nbsp;{" "}
        <strong>{longitudeCardinal} </strong>
        {longitude}
      </p>
    );
  };

  return (
    <div className="ar-content">
      <div className="header-content">
        <img
          className="close-color"
          src={close}
          onClick={() => closeFn()}
          alt="Chiudi"
        />
        <img
          className="header-img"
          src={
            PUBLIC_URL +
            "/assets/img/luoghi" +
            luogo.path +
            "cover/" +
            luogo.img
          }
          // src={
          //   process.env.PUBLIC_URL +
          //   "/assets/img/luoghi/" +
          //   luogo.urw +
          //   "/cover/" +
          //   luogo.img
          // }
          alt={luogo.tappa}
        />
      </div>

      <div className="ar-content-info">
        <h1 className="text-bold">{luogo.tappa}</h1>
        {cat.map((el) => {
          return luogo?.percorso?.forEach((el2) => {
            if (el.slug === el2.nome)
              <p className="category-cont" style={{ color: el.color }}>
                <img
                  className="icon-info"
                  alt={luogo.tappa}
                  src={
                    PUBLIC_URL +
                    "/assets/img/categorie/" +
                    el.path +
                    "icona/" +
                    el.img
                  }
                />
                <span className="info-mappa-cat" style={{ color: el.color }}>
                  {el.nome}
                </span>
              </p>;
          });
        })}

        <p className="text-regular descr">
          {more ? (
            <span>
              {luogo.descrizione.split("\n").map((item, key) => (
                <span key={key}>
                  {item}
                  <br />
                </span>
              ))}
              <p className="read-more" onClick={() => setMore(false)}>
                {t("general.close")}
              </p>
            </span>
          ) : (
            <span>
              {luogo.breve &&
                luogo.breve.split("\n").map((item, key) => (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                ))}
              <p className="read-more " onClick={() => setMore(true)}>
                Leggi di più
                {/* {t("general.readMore")} */}
              </p>
            </span>
          )}
        </p>
        <Tabs id="uncontrolled-tab-example">
          {luogo.gallery && (
            <Tab eventKey="foto" title="FOTO">
              <Foto gall={luogo.gallery} path={luogo.path}></Foto>
            </Tab>
          )}
          {luogo?.video?.length > 0 && (
            <Tab eventKey="video" title="VIDEO">
              <Video video={luogo.video}></Video>
            </Tab>
          )}
        </Tabs>
      </div>
      <hr></hr>
      <div className="ar-content-info mappa-content">
        <p className="size-18 text-bold">MAPPA</p>
        {/* <p className="label-img">
          <img
            src={
              PUBLIC_URL +
              "/assets/img/luoghi/" +
              luogo.path +
              "/mappa/" +
              luogo.mappa
            }
            alt="Mappa"
          />
        </p> */}
        <LoadScript googleMapsApiKey="AIzaSyCK6QxdS3MoVolfonrt6ev_EGjGnCkes2E">
          <GoogleMap
            mapContainerStyle={{
              width: "100%",
              height: "300px"
            }}
            center={luogo.pos}
            zoom={13}
            options={{
              mapId: "b227bbdf25570d97",
              mapTypeControl: false,
            }}
          >
            {/* <Pin /> */}

            <Marker
              position={luogo.pos}
              icon={"/assets/img/position@2x.png"}
              title="Posizione corrente"
            />

            {/* <Direzione /> */}
          </GoogleMap>
        </LoadScript>
        <br></br>
        <p className="descr text-regular">{luogo.indirizzo}</p>
        {luogo.pos && convertDMS(luogo.pos.lat, luogo.pos.lng)}
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  ...state,
});

export default connect(mapStateToProps)(Content);
